
import { BuilderComponentState } from '@builder.io/react/dist/types/src/components/builder-component.component'
import './index.css'

type PaymentAuthorizationNoticeProps = {
  noticeText?: string;
  builderState?: BuilderComponentState;
};

export function FallbackPaymentAuthorizationNotice() {
  return (
    <p className="font-light">
      {`By continuing, I authorize Aeroflow Healthcare to contact me by email,
      phone, or SMS. Aeroflow will not share or distribute this information. I
      also agree to `}
      <a
        href={`https://shop.aeroflowsleep.com/terms-and-conditions`}
        target="_blank"
        rel="noreferrer"
        referrerPolicy="no-referrer"
        className="a"
      >
        {`Aeroflow Terms and Conditions.`}
      </a>
    </p>
  )
}

// rich text input type
export default function PaymentAuthorizationNotice({
  noticeText,
  builderState
}: PaymentAuthorizationNoticeProps ) {
  const text = noticeText || builderState?.state?.noticeText

  return (
    <div
      className="payment-authorization-notice"
      dangerouslySetInnerHTML={{
        __html: text || ``
      }}
    />
  )
}
